export const CHECK_START_MENU:'CHECK_START_MENU' = 'CHECK_START_MENU';

export const REPOSITION_START_MENU_PINED:'REPOSITION_START_MENU_PINED' = 'REPOSITION_START_MENU_PINED';
export const ADD_START_MENU_PINED:'ADD_START_MENU_PINED' = 'ADD_START_MENU_PINED';
export const ADD_START_MENU_PINED_UID:'ADD_START_MENU_PINED_UID' = 'ADD_START_MENU_PINED_UID';
export const REMOVE_START_MENU_PINED:'REMOVE_START_MENU_PINED' = 'REMOVE_START_MENU_PINED';
export const REMOVE_START_MENU_PINED_UID:'REMOVE_START_MENU_PINED_UID' = 'REMOVE_START_MENU_PINED_UID';

export const REPOSITION_START_MENU_TILES:'REPOSITION_START_MENU_TILES' = 'REPOSITION_START_MENU_TILES';
export const ADD_START_MENU_TILES:'ADD_START_MENU_TILES' = 'ADD_START_MENU_TILES';
export const ADD_START_MENU_TILES_UID:'ADD_START_MENU_TILES_UID' = 'ADD_START_MENU_TILES_UID';
export const REMOVE_START_MENU_TILES:'REMOVE_START_MENU_TILES' = 'REMOVE_START_MENU_TILES';
export const REMOVE_START_MENU_TILES_UID:'REMOVE_START_MENU_TILES_UID' = 'REMOVE_START_MENU_TILES_UID';